import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const DynamicArrow: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[8px] h-[13px] stroke-[2px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path d="M3.33347 12.8335V2.77538L1.13771 4.97109C0.877345 5.23145 0.455637 5.23145 0.195273 4.97109C-0.0650911 4.71073 -0.0650911 4.28904 0.195273 4.02868L3.5288 0.695242L3.57925 0.649668C3.84112 0.435942 4.22708 0.451102 4.47123 0.695242L7.80475 4.02868L7.85033 4.07914C8.06406 4.341 8.0489 4.72695 7.80475 4.97109C7.56061 5.21523 7.17464 5.23039 6.91278 5.01666L6.86232 4.97109L4.66655 2.77538V12.8335C4.66655 13.2017 4.36822 13.5 4.00001 13.5C3.6318 13.5 3.33347 13.2017 3.33347 12.8335Z" fill="inherit" />
  </svg>
);

export default DynamicArrow;
